import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var OrdersReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default OrdersReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/ProblemOrders/problemOrdersReduxProps.ts
// module id = 403
// module chunks = 0